"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconShopping = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M11 13.2857C8.6988 13.2857 6.8333 11.3669 6.8333 9L8.5 9C8.5 10.4202 9.6193 11.5714 11 11.5714C12.3807 11.5714 13.5 10.4202 13.5 9L15.1667 9C15.1667 11.3669 13.3012 13.2857 11 13.2857M11 4.7143C12.3807 4.7143 13.5 5.8656 13.5 7.2857L8.5 7.2857C8.5 5.8656 9.6193 4.7143 11 4.7143M16.8333 7.2857 15.1667 7.2857C15.1667 6.1491 14.7277 5.059 13.9463 4.2553C13.1649 3.4515 12.1051 3 11 3C8.6988 3 6.8333 4.9188 6.8333 7.2857L5.1667 7.2857C4.2417 7.2857 3.5 8.0486 3.5 9L3.5 19.2857C3.5 20.2325 4.2462 21 5.1667 21L16.8333 21C17.7538 21 18.5 20.2325 18.5 19.2857L18.5 9C18.5 8.0486 17.75 7.2857 16.8333 7.2857Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconShopping')(IconShopping);